/**
 * @fileoverview A component that ensures that only authenticated users can access the content.
 * It uses the `useUserAPI` hook to check if the user is authenticated.
 *
 * @example
 * <ProtectedRoute><div>Authenticated content</div></ProtectedRoute>
 */

import { DateTime } from 'luxon'
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useAssets } from '../hooks/useAssets'
import { logout } from '../utils/logout'

/**
 * @function PublicRoot
 * @description Component for ensuring that only authenticated users can access the content.
 * @returns {JSX.Element | null} - The PublicRoot component.
 */
export function PublicRoot() {
    const areAssetsReady = useAssets()

    useEffect(() => {
        setInterval(() => {
            const token = localStorage.getItem('token')
            const expiringAt = localStorage.getItem('expiringAt')
            if (!token || !expiringAt) {
                return
            }

            const isAboutToExpire =
                DateTime.fromMillis(Number(expiringAt)).diffNow().toMillis() < 1000

            if (isAboutToExpire) {
                logout('timeout')
            }
        }, 1_000)
    }, [])

    if (!areAssetsReady) {
        return null
    }

    return <Outlet />
}
